module.exports = __webpack_public_path__ + "static/img/智慧网银_文字_png@2x.ee3f0824.png";